import React from 'react';
import { Button, Text, View } from "../../../src/Components/Themed"
import type { CompanyProps, MyPlayerProps, PlayerBalanceProps } from "../../../src/types"
import { Image, type ViewStyle } from 'react-native';
import { Icons } from '../../../src/Components';
import { useColors } from '../../../src/constants/useColors';

type MarketHeaderProps = {
    me?:MyPlayerProps,
    header_style?:ViewStyle,
    my_balance?:PlayerBalanceProps,
    company?:CompanyProps,
    onRequestAuthenticate: () => void,
    onShowProfile:() => void,
    onShowWallet:() => void,
    mode:'desktop'|'mobile',
    onClose?:() => void
}


const MarketHeader = ({me, company, my_balance, header_style, onRequestAuthenticate, onShowProfile, onShowWallet, onClose }:MarketHeaderProps) => {
    const Colors = useColors();

    return (
        <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, ...header_style }}>
            {me ?
            <Button transparent style={{ flexDirection:'row', alignItems:'center', padding:0 }} onPress={() => onShowProfile()}>
                <View float style={{ padding:2, borderRadius:100 }}>
                    <Image
                        source={{ uri: me.profile_pic }}
                        style={{ height:35, width:35, borderRadius:100 }}
                    />
                </View>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    {me.first_name ?
                    <Text theme='h2'>{me.first_name} {me.last_name}</Text>
                    :
                    <Text theme='h2' color={Colors.text.action}>Set up my profile</Text>
                    }
                    <Text theme='description' style={{ marginTop:3 }}>@{me.username}</Text>
                </View>
            </Button>
            :
            <View transparent style={{ flexDirection:'row' }}>
                <View float style={{ padding:0, borderRadius:100, height:37, width: 37, justifyContent:'center', alignItems:'center' }}>
                    <Icons.BettorEdgeIcon size={12} color={Colors.text.h1} />
                </View>
                <View transparent style={{ marginLeft:10 }}>
                    <Text theme='h1'>BettorEdge</Text>
                    <Text theme='description' style={{ marginTop:2 }}>Proud partner of {company?.company_name}</Text>
                </View>
            </View>
            }
            <View transparent style={{ flex:1 }}/>
            {!me ?
            <Button type='success' style={{ flexDirection:'row', padding:10, alignItems:'center' }} onPress={() => onRequestAuthenticate()}>
                <Icons.BettorEdgeIcon size={10} color={Colors.text.white} />
                <Text style={{ marginLeft:5 }} theme='h2' color={Colors.text.white}>Get Started</Text>
            </Button>
            :<></>}
            {my_balance ?
            <Button transparent onPress={() => onShowWallet()}>
                {my_balance.balance > 0 ?
                <Text theme='h1' color={Colors.text.success}>${my_balance.balance.toFixed(2)}</Text>
                :
                <Text theme='h1' color={Colors.text.bronze}>E{my_balance.free_market_balance.toFixed(2)}</Text>
                }
                {my_balance.promo_balance > 0 ?
                <Text theme='success'>Promo: {my_balance.promo_balance.toFixed(2)}</Text>
                : my_balance.balance > 0 ?
                <Text theme='description'>E{my_balance.free_market_balance.toFixed(2)}</Text>
                :<></>}
            </Button>
            :<></>}
            {onClose ?
            <Button float style={{ marginLeft:8, height:35, width:35, borderRadius:100, padding:0, justifyContent:'center', alignItems:'center' }} onPress={() => onClose()}>
                <Icons.CloseIcon color={Colors.text.error} size={14}/>
            </Button>
            :<></>}
        </View>
    )
}

export default MarketHeader